import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { useGetMyAccount, useGetMyProfile } from "../../../../api/queries";
import useSiteConfigAuth from "../../../../api/sanity/queries/getSiteConfigWithCode";
import H2 from "../../../../components/H2";
import Spacer from "../../../../components/Spacer";
import StatementsTable from "../../../../components/StatementsTable";
import { processKycStatuses } from "../../../../helpers/kycStatus";
// import AppState from "../../../../store/appstate";
import useAppStore from "../../../../store/appStateZustand";

function Statements() {
  const history = useHistory();
  const { t } = useTranslation("other");
  const profile = useGetMyProfile();
  // const selectedAccount = AppState.useState(s => s.selectedAccount) || "";
  const selectedAccount = useAppStore(s => s.selectedAccount);
  const myAccount = useGetMyAccount({ artistaccountcode: selectedAccount });
  const { data: siteConfig } = useSiteConfigAuth();
  // const kyc = AppState.getRawState()?.kyc;
  const kyc = useAppStore(s => s.kyc) || {};
  const { showKyc, showKycPending } = processKycStatuses(kyc);
  const hideRoyalties = siteConfig?.disable_statements
    || profile?.data?.hideroyalties
    || showKyc
    || showKycPending || myAccount?.data?.hideroyalties;

  useEffect(() => {
    if (hideRoyalties) {
      history.push("/");
    }
  }, [hideRoyalties, history]);
  return (
    <div className="flex flex-wrap">
      <div className="w-full lg:min-h-screen-minus-header">
        <div className="mx-4 my-12 lg:mx-12 xl:mx-20 2xl:mx-40">
          <H2>{t("other:statements-header")}</H2>
          <Spacer />
          <StatementsTable />
        </div>
      </div>
    </div>
  );
}
export default Statements;
